import React, { useState } from 'react';
import { Redirect } from "react-router-dom";
import axios from 'axios';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  FormGroup,
  Input,
  Label,
  Button,
  Table,
} from 'reactstrap';
import qs from 'query-string';
import authProtection from '../../HOCs/authProtection';
import { CLOUDINARY_THUMB } from '../../helpers/cloudinaryConstants';
import LoaderSpinner from "../Widgets/LoaderSpinner";
import EnterTVName from '../Components/Modals/EnterTVName';
import Alert from "../Widgets/Alert";
import withAlertTimeout from '../../HOCs/withAlertTimeout';
import DeleteTVModal from '../Components/Modals/DeleteTVModal';
import EditTVModal from '../Components/Modals/EditTVModal';
import ActiveTVController from '../Components/Modals/ActiveTVController';


const GoNationTV = props => {

  const [businessSearch, setBusinessSearch] = useState({
    businessName: '',
    businessCity: '',
    isSearching: false,
  });
  const [businessResults, setBusinessResults] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [noResults, setNoResults] = useState(false);
  const [redirectURL, setRedirectURL] = useState(null);
  const token = sessionStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };
  const [showTVNameModal, setShowTVNameModal] = useState(false)
  const [showDeleteTVModal, setShowDeleteTVModal] = useState(false)
  const [showTVController, setShowTVController] = useState(false)
  const [showEditTVModal, setShowEditTVModal] = useState(false)
  const [selectedBusiness, setSelectedBusiness] = useState(null)
  const [tvName, setTvName] = useState('')
  const [successMessage, setSuccessMessage] = useState(null)
  const [tvList, setTvList] = useState(null)
  const [selectedTV, setSelectedTV] = useState(null)

  const handleBusinessSearch = () => {

    setIsSubmitting(true);
    setBusinessSearch({
      ...businessSearch,
      isSearching: true,
    });

    const query = {};
    if (businessSearch.businessName) {
      query.name = businessSearch.businessName;
    }

    if (businessSearch.businessCity) {
      query.geofence = businessSearch.businessCity;
    }

    // todo refactor out the isSearching: false's
    axios
      .get(`/api/proxy/v2/businesses?${qs.stringify(query)}`, headers)
      .then(({ data }) => {
        setBusinessResults(data.items);
        
        setNoResults(!data.items.length)
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        setIsSubmitting(false);
        setBusinessSearch({
          ...businessSearch,
          isSearching: false,
        });
      });
  };

  const getAllTvData = (businessID, type) => {
    axios
    .get(`https://main.dev.gonation.com/api/proxy/v2/businesses/${businessID}/gntv`, {
        headers: { Authorization: `Bearer ${token}` },
    })
    .then(({ data }) => {
        setTvList(data)
        if (type === "delete") setShowDeleteTVModal(true)
        else setShowEditTVModal(true)
    })
    .catch(error => {
        console.log(error)
    })
  }

  const onCreateClick = (business) => {
      
    return e => {
        e.stopPropagation();
        setSelectedBusiness(business)
        setShowTVNameModal(true)
      };
    
  }

  const onChange = (tvName) => {
    setTvName(tvName)
  }

  const onCreateTV = () => {
    const body = {
        "id": "",
        "businessId": selectedBusiness.id,
        "slideDuration": 5000,
        "showTicker": false,
        "showPrices": true,
        "activeTypes": {
            "list1" : [ "items", "events", "shout" ],
            "anyString2": []
        },
        "displayType": {
            "type": "default"
        },
        "filteredOutSections": [],
        "eventItems": [],
        "flyerModeEvents": [],
        "albumNames": [],
        "otherOptions": {
            "TVName": tvName,
            "listViewDuration": 4000000
        }
    }
    setIsCreating(true)
    axios
    .post(`https://main.dev.gonation.com/api/proxy/v2/businesses/${selectedBusiness.id}/gntv`, body, {
        headers: { Authorization: `Bearer ${token}` },
    })
    .then(({ data }) => {
        setSuccessMessage(`GoNation TV with Id ${data.id} has been created.`)
        props.showSuccess()
    })
    .catch(error => {
        console.log(error)
        props.showFailure()

    })
    .finally(() => {
        setIsCreating(false);
        setShowTVNameModal(false)
    })
        
  }

  const onDeleteTV = (tvID) => {
    setIsDeleting(true)
    axios
    .delete(`https://main.dev.gonation.com/api/proxy/v2/businesses/${selectedBusiness.id}/gntv/${tvID}`, {
        headers: { Authorization: `Bearer ${token}` },
    })
    .then(({ data }) => {
        console.log(data)
        setSuccessMessage(`GoNation TV with Id ${tvID} has been deleted.`)
        props.showSuccess()
    })
    .catch(error => {
        console.log(error)
        props.showFailure()

    })
    .finally(() => {
        setIsDeleting(false);
        setShowDeleteTVModal(false)
    })
  }

  const onEditTV = (tv) => {
    setSelectedTV(tv)
    setShowEditTVModal(false)
    setShowTVController(true)

  }

  const onDeleteClick = (business) => {
    return e => {
        e.stopPropagation();
        setSelectedBusiness(business)
        getAllTvData(business.id, "delete")
      };
    
  }

  const onEditClick = (business) => {
    return e => {
        e.stopPropagation();
        setSelectedBusiness(business)
        getAllTvData(business.id, "edit")
      };
  }

  const closeModal = () => {
    setShowTVNameModal(false)
    setShowDeleteTVModal(false)
    setShowEditTVModal(false)
  }


  const renderResults = () => {
    return businessResults.map(business => (
      <tr
        // onClick={
        //   handleBusinessClick(business.id)
        // }
        key={business.id}
        className='user-table__item'>
        <td className='text-center'>
          <div className='avatar'>
            <img
              src={`${CLOUDINARY_THUMB}/${business.avatar.image.cloudinaryId}`}
              className='img-avatar'
              alt={business.name}
            />
          </div>
        </td>
        <td className='text-center'>
          <div>{business.name}</div>
        </td>
        <td className='text-center'>
          <div>{business.id}</div>
        </td>
        <td className='text-center'>
            <Button
              onClick={onCreateClick(business)}
              color="primary"
            >
              Create a TV
            </Button>
        </td>
        <td className='text-center'>
            <Button
              onClick={onDeleteClick(business)}
              color="danger"
            >
              Delete a TV
            </Button>
        </td>
        <td className='text-center'>
            <Button
              onClick={onEditClick(business)}
              color="success"
            >
              Edit a TV
            </Button>
        </td>
      </tr>
    ));
  };

  if (redirectURL) {
    return <Redirect to={redirectURL} />;
  }

  return [
    <EnterTVName
        key="tvNameModal"
        open={showTVNameModal}
        onClose={closeModal}
        onChange={onChange}
        onCreateTV={onCreateTV}
        buttonsDisabled={isCreating}
        inputValue={tvName}
    />,
    <DeleteTVModal
        key="deleteTvModal"
        open={showDeleteTVModal}
        onClose={closeModal}
        onDeleteTV={onDeleteTV}
        tvList={tvList}
        selectedBusiness={selectedBusiness}
    />,
    <EditTVModal
        key="editTvModal"
        open={showEditTVModal}
        onClose={closeModal}
        onEditTV={onEditTV}
        tvList={tvList}
        token={token}
        selectedBusiness={selectedBusiness}
    />,
    <React.Fragment>
        {showTVController &&     
        <ActiveTVController
            data={selectedTV}
            token={token}
            id={selectedBusiness.id}
        />}
        {<Alert active={props.success} message={successMessage} />}
        {
          <Alert
            type="danger"
            active={props.failure}
            message="Something went wrong, please try again"
          />
        }
        <Card>
            <CardHeader>Search for a Business by Name</CardHeader>
            <CardBody>
                <FormGroup>
                <Label htmlFor='business name'>Business Name</Label>
                <Input
                    type='text'
                    name='businessName'
                    id='business-name-input'
                    placeholder='Enter Business Name'
                    value={businessSearch.businessName}
                    onChange={e =>
                    setBusinessSearch({
                        ...businessSearch,
                        [e.target.name]: e.target.value,
                    })
                    }
                />
                </FormGroup>
                <FormGroup>
                <Label htmlFor='business city'>Business City</Label>
                <Input
                    type='text'
                    name='businessCity'
                    id='business-city-input'
                    placeholder='Enter Business City'
                    value={businessSearch.businessCity}
                    onChange={e =>
                    setBusinessSearch({
                        ...businessSearch,
                        [e.target.name]: e.target.value,
                    })
                    }
                />
                </FormGroup>
                <Button color='primary' onClick={() => handleBusinessSearch()}>
                Search
                </Button>
            </CardBody>
            </Card>
            {isSubmitting && <LoaderSpinner />}
            {!isSubmitting && noResults && (
              <h4 style={{ textAlign: "center" }}>No Businesses Found</h4>
            )}
            {businessResults.length ? (
                <Table
                hover
                responsive
                className='table-outline mb-0 d-none d-sm-table user-table'>
                <thead className='thead-light'>
                    <tr>
                    <th className='text-center'>
                        <i className='icon-people' />
                    </th>
                    <th className='text-center'>Name</th>
                    <th className='text-center'>Business ID</th>
                    <th className='text-center'>Create TV</th>
                    <th className='text-center'>Delete TV</th>
                    <th className='text-center'>Edit TV</th>
                    </tr>
                    {renderResults()}
                </thead>
                <tbody />
                </Table>
            ) : (
                ''
            )}
        
    </React.Fragment>
  ]
  
};


export default authProtection(withAlertTimeout(GoNationTV));



// WEBPACK FOOTER //
// ./src/views/Pages/GoNationTV.js